import { entityMatchesId } from "./numbers";

const findAdGroupIndex = (adsGroups, adGroupID) =>
  (adsGroups || []).findIndex((group) => entityMatchesId(group, adGroupID));

const findAdIndex = (ads, adID) =>
  (ads || []).findIndex((ad) => entityMatchesId(ad, adID));

const findAssetsGroupIndex = (assetsGroups, assetsGroupID) =>
  (assetsGroups || []).findIndex((group) =>
    entityMatchesId(group, assetsGroupID)
  );

/**
 * Resolves react-hook-form base path for creative optimization slots
 * (ads, asset groups, ad groups) from current section IDs.
 */
export const getFormPathForCreativeSlot = ({
  getValues,
  adGroupID,
  adID,
  assetsGroupID,
}) => {
  if (assetsGroupID) {
    const assetsGroups = getValues("assetsGroups");
    const groupIndex = findAssetsGroupIndex(assetsGroups, assetsGroupID);
    return groupIndex >= 0 ? `assetsGroups.[${groupIndex}]` : undefined;
  }
  if (adGroupID && adID) {
    const adsGroups = getValues("adsGroups");
    const groupIndex = findAdGroupIndex(adsGroups, adGroupID);
    if (groupIndex < 0) return undefined;
    const adIndex = findAdIndex(adsGroups[groupIndex].ads, adID);
    return adIndex >= 0
      ? `adsGroups.[${groupIndex}].ads.[${adIndex}]`
      : undefined;
  }
  if (adGroupID) {
    const adsGroups = getValues("adsGroups");
    const groupIndex = findAdGroupIndex(adsGroups, adGroupID);
    return groupIndex >= 0 ? `adsGroups.[${groupIndex}]` : undefined;
  }
  return undefined;
};

export const getCreativeOptimizationSlotKey = ({ formPath, field }) => {
  return `${formPath}::${field}`;
};

export const buildCreativeOptimizationPrompt = ({ title, action }) => {
  const parts = [title, action].filter(Boolean);
  return parts.join("\n\n");
};

const URL_KEYS_CREATIVE_OPT = ["title", "action", "field"];

export const stripCreativeOptimizationKeysFromObject = (obj) => {
  if (!obj || typeof obj !== "object") return obj;
  const next = { ...obj };
  URL_KEYS_CREATIVE_OPT.forEach((k) => {
    delete next[k];
  });
  return next;
};

export const getCreativeOptimizationEntryForSlot = ({
  creativeOptimizations,
  formPath,
  field,
}) => {
  if (!formPath || !field || !creativeOptimizations) return null;

  const allKey = getCreativeOptimizationSlotKey({
    formPath,
    field,
  });
  if (creativeOptimizations[allKey]) {
    return creativeOptimizations[allKey];
  }

  return (
    Object.values(creativeOptimizations).find(
      (entry) => entry?.formPath === formPath && entry?.field === field
    ) || null
  );
};
